(function () {
  'use strict';

  /* Injecter le style une seule fois */
  function injectStyle() {
    if (document.getElementById('dmx-jdgm-style')) return;
    var s = document.createElement('style');
    s.id = 'dmx-jdgm-style';
    s.textContent = [
      '[class*="jdgm"]{font-family:"Montserrat",sans-serif!important}',
      /* Titre */
      '.jdgm-heading{font-size:0!important;border-bottom:1px solid rgba(11,90,143,.12)!important;padding-bottom:10px!important;margin-bottom:16px!important;display:block!important;background:none!important;-webkit-text-fill-color:transparent!important}',
      '.jdgm-heading *{display:none!important}',
      '.jdgm-heading::before{content:"Avis clients"!important;display:block!important;font-family:"Space Mono",monospace!important;font-size:10px!important;font-weight:700!important;letter-spacing:.20em!important;text-transform:uppercase!important;background:linear-gradient(90deg,#0B5A8F,#E25D0F)!important;-webkit-background-clip:text!important;-webkit-text-fill-color:transparent!important;background-clip:text!important}',
      /* Étoiles */
      '.jdgm-star,.jdgm__star,[class*="jdgm-star"]{color:#FFC107!important;-webkit-text-fill-color:#FFC107!important}',
      '.jdgm-star--empty{color:rgba(255,193,7,.2)!important;-webkit-text-fill-color:rgba(255,193,7,.2)!important}',
      /* Histo */
      '.jdgm-histogram{margin-bottom:20px!important}',
      '.jdgm-histogram__item{display:flex!important;align-items:center!important;gap:10px!important;margin-bottom:8px!important}',
      '.jdgm-histogram__label{font-family:"Space Mono",monospace!important;font-size:10px!important;color:#888!important;-webkit-text-fill-color:#888!important;min-width:28px!important;text-align:right!important;flex-shrink:0!important}',
      '.jdgm-histogram__bar-container{flex:1!important;height:auto!important;background:transparent!important;overflow:visible!important;display:flex!important;align-items:center!important}',
      '.jdgm-histogram__bar{display:none!important}',
      '.jdgm-histogram__bar-container::before{content:"\u2605\u2605\u2605\u2605\u2605"!important;font-size:14px!important;color:#FFC107!important;-webkit-text-fill-color:#FFC107!important;letter-spacing:2px!important;line-height:1!important;display:block!important}',
      '.jdgm-histogram__count{font-family:"Space Mono",monospace!important;font-size:9px!important;color:#aaa!important;-webkit-text-fill-color:#aaa!important;min-width:24px!important;flex-shrink:0!important}',
      /* Avis */
      '.jdgm-review{background:rgba(255,255,255,.93)!important;border:1.5px solid rgba(11,90,143,.10)!important;border-radius:12px!important;box-shadow:0 2px 12px rgba(0,0,0,.05)!important;padding:16px 20px!important;margin-bottom:12px!important;position:relative!important;overflow:hidden!important}',
      '.jdgm-review::after{content:""!important;position:absolute!important;bottom:0!important;left:0!important;right:0!important;height:2px!important;background:linear-gradient(90deg,#0B5A8F,#5ba3d0,#E25D0F)!important;pointer-events:none!important}',
      '.jdgm-review__author{font-family:"Montserrat",sans-serif!important;font-size:12px!important;font-weight:700!important;color:#1a1a1a!important;-webkit-text-fill-color:#1a1a1a!important}',
      '.jdgm-review__title{font-family:"Montserrat",sans-serif!important;font-size:13px!important;font-weight:700!important;color:#0B5A8F!important;-webkit-text-fill-color:#0B5A8F!important;margin:8px 0 6px!important;line-height:1.4!important}',
      '.jdgm-review__body,.jdgm-review__body p{font-family:"Montserrat",sans-serif!important;font-size:12px!important;color:#555!important;-webkit-text-fill-color:#555!important;line-height:1.72!important}',
      '.jdgm-review__timestamp{font-family:"Space Mono",monospace!important;font-size:8px!important;color:#ccc!important;-webkit-text-fill-color:#ccc!important}',
      /* Boutons */
      '.jdgm-write-review-btn,.jdgm-button{font-family:"Montserrat",sans-serif!important;font-size:11px!important;font-weight:700!important;letter-spacing:.10em!important;text-transform:uppercase!important;background:linear-gradient(90deg,#0B5A8F,#5ba3d0,#E25D0F)!important;color:#fff!important;-webkit-text-fill-color:#fff!important;border:none!important;border-radius:8px!important;padding:10px 20px!important;cursor:pointer!important}',
      '.jdgm-load-more-btn{font-family:"Montserrat",sans-serif!important;font-size:11px!important;font-weight:700!important;letter-spacing:.08em!important;text-transform:uppercase!important;border:2px solid transparent!important;background-image:linear-gradient(rgba(255,255,255,.96),rgba(255,255,255,.96)),linear-gradient(90deg,#0B5A8F,#E25D0F)!important;background-origin:border-box!important;background-clip:padding-box,border-box!important;color:#0B5A8F!important;-webkit-text-fill-color:#0B5A8F!important;border-radius:8px!important;padding:10px 24px!important;cursor:pointer!important}',
      '.jdgm-review__verified-badge{font-family:"Space Mono",monospace!important;font-size:8px!important;color:#0B5A8F!important;-webkit-text-fill-color:#0B5A8F!important;background:rgba(11,90,143,.07)!important;border:1px solid rgba(11,90,143,.18)!important;border-radius:20px!important;padding:2px 7px!important;letter-spacing:.08em!important;text-transform:uppercase!important}'
    ].join('\n');
    document.head.appendChild(s);
  }

  /* Traduire "Customer Reviews" */
  function fixHeading() {
    document.querySelectorAll('.jdgm-heading').forEach(function (el) {
      if (el.dataset.dmxFixed) return;
      el.dataset.dmxFixed = '1';
      /* Vider le contenu — le ::before CSS affiche "Avis clients" */
      Array.from(el.childNodes).forEach(function (n) { n.remove(); });
    });
  }

  /* Traduire "Based on X reviews" */
  function fixBasedOn() {
    document.querySelectorAll('.jdgm-based-on').forEach(function (el) {
      if (el.dataset.dmxFixed) return;
      el.dataset.dmxFixed = '1';
      var text = el.innerText || el.textContent || '';
      var match = text.match(/(\d+)/);
      var count = match ? match[1] : '0';
      el.innerHTML = 'Bas\u00e9 sur <strong style="color:#0B5A8F;-webkit-text-fill-color:#0B5A8F;font-weight:700">' + count + '</strong> avis';
      el.style.cssText = 'font-family:"Space Mono",monospace!important;font-size:9px!important;letter-spacing:.10em!important;color:#aaa!important;-webkit-text-fill-color:#aaa!important;margin-bottom:16px!important;display:block!important';
    });
  }

  /* Masquer les lignes à 0 avis */
  function hideZeroRows() {
    document.querySelectorAll('.jdgm-histogram__item').forEach(function (item) {
      var count = item.querySelector('.jdgm-histogram__count');
      if (!count) return;
      var txt = count.textContent.trim();
      /* (0) ou 0 */
      if (txt === '(0)' || txt === '0') {
        item.style.setProperty('display', 'none', 'important');
      }
    });
  }

  /* Tout appliquer */
  function applyAll() {
    injectStyle();
    fixHeading();
    fixBasedOn();
    hideZeroRows();
  }

  /* Observer le DOM pour attraper le widget quand il apparaît */
  var applied = false;
  var observer = new MutationObserver(function () {
    if (document.querySelector('.jdgm-widget, .jdgm-review-widget, .jdgm-heading, .jdgm-based-on')) {
      applyAll();
      /* Rappliquer après un court délai car le widget peut encore charger des éléments */
      if (!applied) {
        applied = true;
        setTimeout(applyAll, 300);
        setTimeout(applyAll, 800);
        setTimeout(applyAll, 2000);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  /* Appliquer aussi immédiatement au cas où le widget est déjà présent */
  applyAll();
  setTimeout(applyAll, 500);
  setTimeout(applyAll, 1500);
  setTimeout(applyAll, 3000);

})();
